import React from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { DocManiaLogo, DocManiaLogoImage } from '../components/DocManiaLogo';
import { CreditBadge } from '../components/CreditBadge';
import { ArrowLeft } from 'lucide-react';
import TemplateSelectorPanel from '../components/tools/TemplateSelectorPanel';

export default function TemplateSelectionPage({ fixedDocumentType, fixedCategory }) {
  const { documentType: routeDocumentType } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const documentType = fixedDocumentType || routeDocumentType;
  const categoryFilter = fixedCategory || searchParams.get('category') || null;

  return (
    <div className="min-h-screen bg-muted/20">
      <header className="border-b border-border bg-white">
        <div className="max-w-6xl mx-auto flex items-center justify-between h-16 px-6">
          <div className="flex items-center gap-4">
            <Button variant="ghost" size="icon" onClick={() => navigate(user ? '/dashboard' : '/')} data-testid="back-to-dashboard-btn">
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div className="flex items-center gap-2">
              <DocManiaLogoImage size={28} />
              <DocManiaLogo size="small" />
            </div>
          </div>
          {user && <CreditBadge balance={user.credit_balance} />}
        </div>
      </header>

      <main className="max-w-6xl mx-auto p-6 lg:p-10">
        <TemplateSelectorPanel
          documentType={documentType}
          categoryFilter={categoryFilter}
        />
      </main>
    </div>
  );
}
